import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchDeviceAnalytics } from 'store/actions/adminActions';
import Api from 'api/admin';

export function* fetchDeviceAnalyticsSaga(action: any) {
  try {
    const response = yield call(Api.fetchDeviceAnalytics, {
      params: action.payload,
    });
    yield put({ type: fetchDeviceAnalytics.success, payload: response.data });
  } catch (error) {
    const err = error as Error;
    yield put({ type: fetchDeviceAnalytics.failure, payload: err.message });
  }
}

export function* watchFetchDeviceAnalytics() {
  yield takeLatest(fetchDeviceAnalytics.request, fetchDeviceAnalyticsSaga);
}
